import React, { useEffect, useState } from "react";
import NewTitle from "../../extra/Title";
import dayjs from "dayjs";

import { useDispatch, useSelector } from "react-redux";
import Managegoldenbadge from "./Managegoldenbadge";

import { gettingTheBadgeUser } from "../../store/goldenBadge/badge.action";
import Premiumbadgeusers from "./PremiumbadgePage";

export default function GoldenbadgePage() {
  const [multiButtonSelect, setMultiButtonSelect] = useState("Golden Badge");

  const [startDate, setStartDate] = useState("All");
  const [endDate, setEndDate] = useState("All");
  const { dialogue, dialogueType, dialogueData } = useSelector(
    (state) => state.dialogue
  );

  const startDateFormat = (startDate) => {
    return startDate && dayjs(startDate).isValid()
      ? dayjs(startDate).format("YYYY-MM-DD")
      : "All";
  };
  const endDateFormat = (endDate) => {
    return endDate && dayjs(endDate).isValid()
      ? dayjs(endDate).format("YYYY-MM-DD")
      : "All";
  };

  const startDateData = startDateFormat(startDate);
  const endDateData = endDateFormat(endDate);

  return (
    <div className="userPage videoPage">
      <div>
        <div className="dashboardHeader primeHeader mb-3 p-0">
          <NewTitle
            dayAnalyticsShow={false}
            setEndDate={setEndDate}
            setStartDate={setStartDate}
            startDate={startDate}
            endDate={endDate}
            name={`Badges`}
            titleShow={true}
            setMultiButtonSelect={setMultiButtonSelect}
            multiButtonSelect={multiButtonSelect}
            labelData={["Premium Badge", "Golden Badge"]}
          />
        </div>

        {multiButtonSelect == "Golden Badge" && (
          <Managegoldenbadge startDate={startDate} />
        )}
        {multiButtonSelect == "Premium Badge" && (
          <Premiumbadgeusers startDate={startDate} endDate={endDate} />
        )}
      </div>
    </div>
  );
}
